import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    end: Number,
    unit: String,
  };

  static targets = ["timer"];

  declare endValue: number;
  declare unitValue: string;
  declare timerTarget: HTMLTimeElement;

  connect() {
    // Set the date we're counting down to
    const countDownDate = new Date(this.endValue * 1000).getTime();

    // Update the count down every 1 second
    const interval = setInterval(() => {
      // Get current time
      const now = new Date().getTime();

      // Find the distance between now and the countdown date
      const delta = countDownDate - now;

      if (delta < 0) {
        // If the countdown is finished, reload the page
        clearInterval(interval);
        document.location.reload();
        return;
      }

      // Update the timer display
      this.timerTarget.textContent = this.timerContent(delta);
    }, 1000);
  }

  timerContent(delta: number): string {
    // Break the remaining time into components
    const { days, hours, minutes, seconds } = this.computeTimeComponents(delta);

    // Return formatted string based on unit preference
    switch (this.unitValue) {
      case "days":
        return `${days} day${days !== 1 ? "s" : ""}`;
      case "hours_minutes_seconds":
        return (
          String(hours).padStart(2, "0") + "h " +
          String(minutes).padStart(2, "0") + "m " +
          String(seconds).padStart(2, "0") + "s"
        );
      default:
        return "";
    }
  }

  computeTimeComponents(delta: number) {
    // Convert delta to total seconds
    const secondsTotal = Math.floor(delta / 1000);
    const useTotalHours = this.unitValue === "hours_minutes_seconds";

    // Calculate individual time units
    const days = Math.ceil(secondsTotal / (60 * 60 * 24)); // 1 day = 86400 seconds
    const hours = useTotalHours
      ? Math.floor(secondsTotal / 3600)
      : Math.floor((secondsTotal % (60 * 60 * 24)) / 3600); // 1 hour = 3600 seconds
    const minutes = Math.floor((secondsTotal % 3600) / 60); // 1 minute = 60 seconds
    const seconds = secondsTotal % 60;

    return { days, hours, minutes, seconds };
  }
}
